import { z } from 'zod';
import { guardExhaustive } from 'libs/end-to-end/src/generic';

export const ImpactFactor = z
  .enum(['Low', 'Medium', 'High'])
  .describe('ImpactFactor');
export type ImpactFactor = z.infer<typeof ImpactFactor>;

export const impactFactorAsNumber = (impactFactor: ImpactFactor): number => {
  switch (impactFactor) {
    case 'Low':
      return 1;
    case 'Medium':
      return 2;
    case 'High':
      return 3;
    default:
      throw guardExhaustive(impactFactor);
  }
};

export const impactFactorNumberToImpactFactor = (
  impactFactor: number,
): ImpactFactor | null => {
  switch (impactFactor) {
    case 1:
      return 'Low';
    case 2:
      return 'Medium';
    case 3:
      return 'High';
    default:
      return null;
  }
};
